import "@memorial/scss/app-memorial.scss"

document.addEventListener("DOMContentLoaded", function () {
    if ($(".home").length > 0) {
        //TODO : Functions
    }
})
